<template>
    <div class="content">
        <div id="heasers">
            <div class="header-wrap">
                <div class="header">
                    <span class="left"
                          @click="goBack"><i class="icon-fanhui"></i></span>
                    <div class="ellipsis">{{type==1?'同步习题':type==2?'每周一测':'单元复习'}}</div>
                    <slot></slot>
                </div>
            </div>
        </div>
        <div v-if="!firstLoad">
            <div v-if="Object.keys(book).length==0">
                <div class="box">
                    <p class="p1"></p>
                    <p class="p2">您暂未设置<em>教材</em></p>
                    <p class="p3">请先设置一本<em>教材</em>吧，设置过后才能布置作业</p>
                    <a href="javascript:;"
                       class="set-book"
                       @click="setbook">设置教材</a>
                </div>
            </div>
            <div v-else>
                <div class="title">
                    <div>
                        <p></p>
                        <p>{{book.book_name}}</p>
                        <p @click="setbook">更换<em>教材</em></p>
                        <p></p>
                    </div>
                </div>
                <!-- 同步习题 -->
                <div class="main"
                     v-if="list.length > 0">
                    <div v-if='type==1'>
                        <div class="main_box"
                             v-for="(i,index) in list">
                            <div class="main_title"
                                 @click="open(i,index)">
                                <p><i></i></p>
                                <p>{{index+1}}.{{i.name}}</p>
                                <p :class="i.choise ? 'list_open' : 'list_close'"
                                   v-if="i.children.length >0"></p>
                                <img v-if='!i.choise && !i.children.length'
                                     src="./img/icon_select.png"
                                     alt="">
                                <img v-if='i.choise && !i.children.length'
                                     src="./img/icon_unchecked.png"
                                     alt="">
                            </div>
                            <transition name="my-slide"
                                        tag="div">
                                <div class="main_con_wrap"
                                     v-show="!i.choise"
                                     :style="`height:${i.children.length * 2.4}rem`">
                                    <div class="main_con"
                                         v-for="q,inx in i.children">
                                        <p>{{q.name}}</p>
                                        <p @click='select(q,index,inx)'>
                                            <img v-if='q.is_select'
                                                 src="./img/icon_select.png"
                                                 alt="">
                                            <img v-else
                                                 src="./img/icon_unchecked.png"
                                                 alt="">
                                        </p>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                    <!-- 单元复习 -->
                    <div v-else>
                        <div class="main_box"
                             v-for="(i,index) in list">
                            <div class="main_title"
                                 @click="unit(i,index)">
                                <p><i></i></p>
                                <p>{{index+1}}.{{i.name}}</p>
                                <p class="item_img">
                                    <img v-if='!i.choise'
                                         src="./img/icon_select.png"
                                         alt="">
                                    <img src="./img/icon_unchecked.png"
                                         alt=""
                                         v-else>
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
                <div v-else>
                    <noResouse></noResouse>
                </div>
            </div>
        </div>
        <div v-else>
            <loading></loading>
        </div>
        <div class="foot"
             v-if="Object.keys(book).length!=0 && list.length">
            <div class="bottom_btn">
                <a class="btn_a"
                   v-if='questions'
                   @click='next'>下一步</a>
                <a v-else>下一步</a>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import { mapState } from 'vuex';
import loading from 'COMPONENTS/base/tealoading.vue'
import noResouse from 'COMPONENTS/noResouse.vue'
import headers from 'COMPONENTS/base/header.vue'
export default {
    data () {
        return {
            sid: this.$route.params.sid,
            type: this.$route.params.type,  //1同步习题 2 单元复习  3每周一测
            hasbook: false,
            firstLoad: true,
            list: [],
            book: [],
            titles: '',
            qid: [],
            questions: 0,
            paperId: [],
            currentIndex: null,
        }
    },
    components: {
        loading,
        noResouse,
        headers
    },
    computed: {},
    watch: {

    },
    async created () {
        //console.log(this.type)
        let math_send_ok = localStorage.getItem('math_send_ok');
        if (math_send_ok == 1) {
            this.$router.go(-1);
            return false;
        }
        this.titles = this.type == 1 ? '同步习题' : this.type == 2 ? '每周一测' : '单元复习'
        let code = ''
        if (this.type == 1) {
            code = '016'
        }
        if (this.type == 2) {
            code = '017'
        }
        if (this.type == 3) {
            code = '019'
        }
        await this.$http.post(API_URL_TASK_API + '/public/book/user_book', {
            sid: this.sid, //学科 21 22
            book_type: 0, // 0 教材 1 教材 2教辅   
            code: code    //004 同步习题
        }).then(resp => {
            let res = resp.data;
            if (res.response === 'ok') {
                this.$store.state.book = res.data;
                this.book = res.data
            }
        });
        if (Object.keys(this.book).length != 0) {
            await this.getlist();
        } else {
            this.firstLoad = false
        }
    },
    methods: {
        setbook () {
            //学科 21 22
            // 0 教材 1 教材
            //004 同步习题  单元复习的code的值一样 
            if (this.type == 1) {
                this.$router.push(`/setBook/21/1/4?task_type=1`)
            }
            if (this.type == 2) {
                this.$router.push(`/setBook/21/1/4?task_type=2`)
            }
            if (this.type == 3) {
                this.$router.push(`/setBook/21/1/4?task_type=3`)
            }


        },
        getlist () {
            if (Object.keys(this.book).length != 0) {
                this.$http.post(API_URL_TASK_API + '/special/book/catalog_list', {
                    sid: this.sid,
                    book_id: this.book.id,
                    test_type: this.type
                }).then(resp => {
                    let res = resp.data;
                    this.firstLoad = false
                    if (res.response === 'ok') {
                        this.list = res.data;
                        this.list.forEach((l, index) => {
                            l.choise = true;
                            if (l.children) {
                                l.children.forEach((m, n) => {
                                    m.is_select = false
                                })
                            }

                        })
                        //console.log(this.list)
                    }
                })
            } else {
                this.firstLoad = false
            }
        },
        open (i, ind) {
            // 同步习题
            if (!i.children.length) {
                if (i.choise) {
                    this.questions += 1
                    this.qid.push(i.id);
                } else {
                    this.questions -= 1
                    let _num = this.qid.findIndex(item => item === i.id);
                    this.qid.splice(_num, 1);
                }
            }
            i.choise = !i.choise;
            this.list.splice(ind, 1, i);
        },
        unit (i, index) {
            // 单元复习
            if (!i.choise) {
                this.questions -= 1
            } else {
                this.questions += 1
            }
            this.qid
            i.choise = !i.choise
            this.list.splice(index, 1, i)
        },
        select (q, index, inx) {
            if (q.is_select) {
                this.questions -= 1
            } else {
                this.questions += 1
            }
            q.is_select = !q.is_select
        },
        next1 () {

            this.$store.commit('setchapterid', this.qid)
            this.$router.push('/sx/testPaper/screen/' + this.sid + '/' + this.type)
        },

        next () {
            localStorage.removeItem('activeData')
            localStorage.removeItem('activeIds')
            // 设置章节ID
            if (this.type == 1) {
                // 同步习题
                this.list.forEach((m, n) => {
                    m.children.forEach((l, i) => {
                        if (l.is_select) {
                            this.qid.push(l.id)
                        }
                    })
                })
            } else {
                this.list.forEach((m, n) => {
                    if (!m.choise) {
                        this.qid.push(m.id)
                    }
                })
            }

            this.$http.post(API_URL_TASK_API + '/maths/send/general/special/catalog/paper', {
                book_id: this.book.id,
                cid: this.qid.join(','),
                sid: '21',
                task_type: this.type
            }).then(res => {
                if (res.data.response === 'ok') {
                    //console.log(res)
                    if (!res.data.data.length) {
                        layer.open({
                            title: "提示",
                            content: '<div class="norecorse"><span class="img"></span><h3>暂无资源</h3> </div>',
                            btn: '确定',
                            yes: function () {
                                layer.closeAll();
                            }

                        });
                        return
                    }
                    res.data.data.forEach(e => {
                        e.paper.forEach(j => {
                            this.paperId.push(j.paper_id)
                        })
                    })
                    localStorage.setItem('qid', this.qid.join(','))
                    localStorage.setItem('book_id', this.book.id)
                    this.$store.commit('setchapterid', this.paperId)

                    setTimeout(() => {
                        this.$router.push('/sx/testPaper/preview/' + this.sid + '/' + 1 + '?typeOf=' + this.type)
                    }, 300)
                }
            })


        },
        goBack () {
            this.$router.push('/mathchooseType/21?type=1&user_type=0&is_show=0')
        },


    },
    beforeDestroy () {
        localStorage.removeItem('activeData')
        localStorage.removeItem('activeIds')
        localStorage.removeItem('filter_qids')
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";
.set-book {
    display: block;
    margin: 40px / $ppr auto 0 auto;
    width: 360px / $ppr;
    height: 82px / $ppr;
    line-height: 82px / $ppr;
    font-size: 30px / $ppr;
    color: #fff;
    background: #5e89ef;
    border-radius: 41px / $ppr;
    text-align: center;
}
.content {
    width: 100%;
    min-height: 100%;
    padding-bottom: 2.4rem;
    .title {
        width: 100%;
        height: 96px / $ppr;
        margin-bottom: 24px / $ppr;
        background: #fff;
        div {
            width: 673px / $ppr;
            height: 96px / $ppr;
            margin: 0 auto;
            p {
                line-height: 96px / $ppr;
                text-align: left;
            }
            p:nth-child(1) {
                width: 34px / $ppr;
                height: 34px / $ppr;
                background: url("img/icon_setbook.png") no-repeat;
                -webkit-background-size: 100% 100%;
                background-size: 100% 100%;
                float: left;
                margin: 31px / $ppr 24px / $ppr 0 0;
            }
            p:nth-child(2) {
                width: 462px / $ppr;
                float: left;
                font-size: 30px / $ppr;
                color: #333;
                @include ellipsis;
            }
            p:nth-child(3) {
                width: 139px / $ppr;
                color: #5e89ef;
                font-size: 30px / $ppr;
                float: left;
            }
            p:nth-child(4) {
                width: 14px / $ppr;
                height: 26px / $ppr;
                float: right;
                margin-top: 34px / $ppr;
                background: url("./img/enter.png") no-repeat;
                -webkit-background-size: 100% 100%;
                background-size: 100% 100%;
            }
        }
    }
    .main {
        width: 100%;
        height: auto;
        background: #fff;
        .main_box {
            width: 100%;
            height: auto;
            .main_title {
                width: 100%;
                height: 96px / $ppr;
                border-bottom: 1px / $ppr solid #e8e8e8;
                position: relative;
                p:nth-child(1) {
                    width: 80px / $ppr;
                    height: 96px / $ppr;
                    float: left;
                    i {
                        display: block;
                        width: 34px / $ppr;
                        height: 32px / $ppr;
                        background: url("img/icon_book.png") no-repeat;
                        -webkit-background-size: 100% 100%;
                        background-size: 100% 100%;
                        margin: 32px / $ppr 22px / $ppr 0 24px / $ppr;
                    }
                }
                p:nth-child(2) {
                    width: 556px / $ppr;
                    height: 96px / $ppr;
                    line-height: 96px / $ppr;
                    font-size: 30px / $ppr;
                    color: #333;
                    float: left;
                    text-align: left;
                    @include ellipsis;
                }
                .item_img {
                    img {
                        width: 45px / $ppr;
                        height: 45px / $ppr;
                        // position:relative;
                        top: 25px / $ppr;
                    }
                }
                .list_open {
                    width: 25px / $ppr;
                    height: 13px / $ppr;
                    background: url("img/icon_open.png") no-repeat;
                    -webkit-background-size: 100% 100%;
                    background-size: 100% 100%;
                    float: right;
                    margin: 41px / $ppr 24px / $ppr 0 0;
                }
                .list_close {
                    width: 25px / $ppr;
                    height: 13px / $ppr;
                    background: url("img/icon_close.png") no-repeat;
                    -webkit-background-size: 100% 100%;
                    background-size: 100% 100%;
                    float: right;
                    margin: 41px / $ppr 24px / $ppr 0 0;
                }
            }
            .main_con {
                width: 100%;
                height: 96px / $ppr;
                background: #f0f0f0;
                position: relative;
                border-bottom: 1px / $ppr solid #e8e8e8;
                overflow: hidden;
                p {
                    float: left;
                    box-sizing: border-box;
                }
                p:nth-child(1) {
                    width: 450px / $ppr;
                    margin-left: 106px / $ppr;
                    line-height: 96px / $ppr;
                    color: #333;
                    font-size: 30px / $ppr;
                    text-align: left;
                    @include ellipsis;
                }
                p:nth-child(2) {
                    width: 80px / $ppr;
                    height: 100%;
                    text-align: center;
                    color: #5e89ef;
                    font-size: 28px / $ppr;
                    position: relative;
                    left: 80px / $ppr;
                }
            }
            .english_title {
                p:nth-child(2) {
                    width: 269px / $ppr;
                    @include ellipsis;
                }
                p:nth-child(3) {
                    width: 136px / $ppr;
                    line-height: 96px / $ppr;
                    text-align: center;
                    color: #5e89ef;
                    font-size: 28px / $ppr;
                    float: left;
                }
                p:nth-child(4) {
                    width: 184px / $ppr;
                    height: 54px / $ppr;
                    border: 1px / $ppr solid #5e89ef;
                    border-radius: 30px / $ppr;
                    margin-top: 20px / $ppr;
                    line-height: 54px / $ppr;
                    text-align: center;
                    font-size: 24px / $ppr;
                    color: #5e89ef;
                    float: left;
                }
            }
        }
        img {
            width: 45px / $ppr;
            height: 45px / $ppr;
            position: absolute;
            top: 25px / $ppr;
            right: 25px / $ppr;
        }
    }
}

.box {
    //无教材
    width: 100%;
    height: auto;
    margin-top: 325px / $ppr;
    p {
        display: block;
    }
    .p1 {
        width: 136px / $ppr;
        height: 112px / $ppr;
        background: url("img/icon_nobook.png") no-repeat;
        -webkit-background-size: 100% 100%;
        background-size: 100% 100%;
        margin: 0 auto;
    }
    .p2 {
        width: 100%;
        text-align: center;
        color: #333;
        font-size: 36px / $ppr;
        line-height: 36px / $ppr;
        margin: 40px / $ppr 0 16px / $ppr 0;
    }
    .p3 {
        width: 100%;
        text-align: center;
        color: #999;
        font-size: 24px / $ppr;
        line-height: 24px / $ppr;
        margin-bottom: 40px / $ppr;
    }
}

.foot {
    position: fixed;
    bottom: 0;
    width: 100%;
    .bottom_btn {
        a {
            display: inline-block;
            height: 97px / $ppr;
            line-height: 97px / $ppr;
            width: 100%;
            color: #999999;
            background-color: $line;
            text-align: center;
            font-size: $lg;
            //font-weight: bold;
            &.btn_a {
                color: #fff;
                background-color: #5e89ef;
            }
        }
    }
    .bottom_btn2 {
        a {
            display: inline-block;
            height: 97px / $ppr;
            line-height: 97px / $ppr;
            width: 100%;
            color: $c-header;
            background-color: $c-theme;
            text-align: center;
            font-size: $lg;
        }
    }
}
.main_con_wrap {
    height: 0;
    overflow: hidden;
    transition: height 0.3s linear;
}
.my-slide-enter,
.my-slide-leave-to {
    height: 0 !important;
}
.header-wrap .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 8;
    height: $h-header;
    line-height: $h-header;
    color: #fff;
    font-size: 34px / $ppr;
    text-align: center;
    background: #5e89ef;
    .icon-fanhui {
        display: block;
        width: 76px / $ppr;
        height: $h-header;
        background-image: url("./img/back.png");
        background-position: center;
        background-size: 18px / $ppr 34px / $ppr;
        background-repeat: no-repeat;
        position: absolute;
        top: 0;
        left: 0;
        cursor: pointer;
    }
    .ellipsis {
        width: 520px / $ppr;
        margin: 0 auto;
    }
}
</style>
